import script from "./MetaNavItem.vue?vue&type=script&lang=ts"
export * from "./MetaNavItem.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__